// Stimulus
import { Application } from '@hotwired/stimulus';
import StimulusControllerResolver from 'stimulus-controller-resolver'; // eslint-disable-line import/no-unresolved

// Turbo
import * as Turbo from '@hotwired/turbo';

// Assets
import '../assets/img/etrusted.svg';
import '../assets/img/logo-about.svg';
import '../assets/img/logo-de.svg';
import '../assets/img/logo-kingsday.svg';
import '../assets/img/logo-mark.svg';
import '../assets/img/logo.svg';
import '../assets/img/vtwonen.svg';
import '../assets/img/webwinkelkeur.svg';

// Email
import '../assets/img/email/facebook.png';
import '../assets/img/email/instagram.png';
import '../assets/img/email/logo-mark.png';
import '../assets/img/email/logo-de.png';
import '../assets/img/email/logo.png';
import '../assets/img/email/pinterest.png';
import '../assets/img/email/youtube.png';

// Icons
import '../assets/img/icons/adjustments-vertical.svg';
import '../assets/img/icons/arrow-down.svg';
import '../assets/img/icons/arrow-right.svg';
import '../assets/img/icons/bars-3.svg';
import '../assets/img/icons/calculator-micro.svg';
import '../assets/img/icons/calculator.svg';
import '../assets/img/icons/check-badge.svg';
import '../assets/img/icons/check-circle.svg';
import '../assets/img/icons/chevron-down.svg';
import '../assets/img/icons/chevron-left.svg';
import '../assets/img/icons/chevron-right.svg';
import '../assets/img/icons/clock.svg';
import '../assets/img/icons/document-currency-euro.svg';
import '../assets/img/icons/envelope-open.svg';
import '../assets/img/icons/information-circle.svg';
import '../assets/img/icons/magnifying-glass.svg';
import '../assets/img/icons/pencil-square.svg';
import '../assets/img/icons/phone.svg';
import '../assets/img/icons/play.svg';
import '../assets/img/icons/plus-circle.svg';
import '../assets/img/icons/shopping-bag.svg';
import '../assets/img/icons/spinner.svg';
import '../assets/img/icons/star-outline.svg';
import '../assets/img/icons/star.svg';
import '../assets/img/icons/swatch.svg';
import '../assets/img/icons/tiles-4.svg';
import '../assets/img/icons/trash.svg';
import '../assets/img/icons/truck.svg';
import '../assets/img/icons/user-circle.svg';
import '../assets/img/icons/x-circle.svg';
import '../assets/img/icons/x-mark.svg';

// Locales
// import '../assets/img/locales/be.svg'; @TODO add belgium site next year
import '../assets/img/locales/de.svg';
import '../assets/img/locales/en.svg';
import '../assets/img/locales/fr.svg';
import '../assets/img/locales/nl.svg';

// Providers
import '../assets/img/providers/applepay.svg';
import '../assets/img/providers/banktransfer.svg';
import '../assets/img/providers/bancontact.svg';
import '../assets/img/providers/belfius.svg';
import '../assets/img/providers/billie.svg';
import '../assets/img/providers/dhl.svg';
import '../assets/img/providers/googlepay.svg';
import '../assets/img/providers/ideal.svg';
import '../assets/img/providers/kbc.svg';
import '../assets/img/providers/klarna.svg';
import '../assets/img/providers/mastercard.svg';
import '../assets/img/providers/paypal.svg';
import '../assets/img/providers/riverty.svg';
import '../assets/img/providers/visa.svg';

// Social
import '../assets/img/social/facebook.svg';
import '../assets/img/social/instagram.svg';
import '../assets/img/social/pinterest.svg';
import '../assets/img/social/youtube.svg';

// Start Stimulus
const application = Application.start();
StimulusControllerResolver.install(application, async (controllerName) => (
  (await import(`./controllers/${controllerName}_controller.js`)).default
));

// Start Turbo
Turbo.start();

// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
  import.meta.hot.accept(() => {
    console.log('HMR'); // eslint-disable-line no-console
  });
}
